<template>
  <div class="the-survey-description" :class="showIcon ? 'showing-icon' : ''">
    <div class="card z-depth-0">
      <div class="card-content grey-text text-darken-4" v-if="expandable">
      <!--    <img class="view" :src="bulb"> -->
          <div v-if="!view" v-html="$_truncate(description)"></div>
          <div v-show="view" v-html="description"></div>
         <button @click="view ? view = false : view = true" class="btn btn-rounded grey darken-3 z-depth-0 white-text waves-effect" style="width: 100%; margin: 12px 0px 0px;"> View More 
           <i class="material-icons white-text  right">expand_more</i>
        </button>
      </div>
      <div v-else class="card-content grey-text text-darken-4">
      <!--  <img class="view" :src="bulb"> -->
          <div v-html="description"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import bulb from '@/assets/light_bulb.svg'
export default {
  name: 'TheSurveyDescription',
  props: {
    description: {
    type: String,
      default: "",
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    expandable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bulb,
      view: false
    };
  },
  mounted() {
    this.$_setupHelpers();
  },
  computed: {},
  methods: {
    ...mapActions("Helpers", ["setHelper"]),

    $_setupHelpers() {
      const helpers = this.$el.querySelectorAll("[helper-id]");

      if (helpers)
        helpers.forEach((helperEl) => {
          helperEl.addEventListener("click", (event) => {
            event.preventDefault();
            const helperId = helperEl.getAttribute("helper-id");
            this.setHelper(helperId);
          });
        });
    },
    $_truncate (x) {
      let holder = document.createElement('DIV')
      holder.innerHTML = x
      return holder.textContent.slice(0, 100)+'...'
    }
  },
};
</script>
<style lang="scss" scoped>
.the-survey-description {
    transition: all 150ms linear;
    font-size: 15px;
 .card {
    background: #fbd15e;
    .card-content {
      padding: 16px;
      display: flex;
      flex-wrap: wrap;
 
      .view {
        font-size: 52px;
        margin:0 18px 0 8px;
      }
      div {
        overflow: hidden;
        position: relative;
       /*  width: calc(100% - 70px) */
      }
    }
 }
}
</style>
<style lang="scss">
.the-survey-description {
  margin-bottom: 16px;
  .card-content {
      padding: 24px !important;
      p {
        margin-bottom: 8px !important;
      }
  
  }
  
    &.showing-icon {
     .card-content {
        &::before {
        position: relative;
        content: 'info_outline';
        position: absolute;
        left: 12px;
        font-family: 'Material Icons Outlined';
        font-size: 34px;
        top: 16px;
      }
     }
    }
  .sectionX-title {
    font-size: 32px;
      font-family: "Libre Franklin", sans-serif;
      line-height: 34px;
      font-weight: 600;
      margin-bottom: 9px;
      margin-top: 0px;
      margin-left: 36px;
  }
}
</style>